export default __webpack_public_path__ + "static/media/porta-tambor.71a762ae.png";